/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.imageEditorModule')

  .directive('bulbImageEditor', ['$state', '$q', '$translate', '$window',
    'BulbBusyService', 'BulbErrorService', 'BulbModalService', 'BulbUploadService', bulbImageEditorFactory]);

/**
 * A directive for an image editor, containing controls for Cancel and (optionally) Delete and a Save button.
 * Use it as the element bulb-image-editor, with attributes as needed:
 *
 *  on-delete: if set, when user presses the Delete button, this function is invoked with no arguments.
 *    For example:
 *      <bulb-image-editor on-delete="someCtrl.onDelete()"></bulb-image-editor>
 *    This function should return a promise.
 *  on-edit-complete: if set, when user saves or cancels the edit, this function is invoked.
 *    On cancel, it is invoked with no arguments.
 *    On save, it is invoked with a single argument named data.
 *    For example:
 *      <bulb-image-editor on-edit-complete="someCtrl.onEditComplete(data)"></bulb-image-editor>
 *    This function should return a promise.
 *
 * This directive transcludes its contents, which can be used, for example,
 * to display transparent content over the editor.
 */
function bulbImageEditorFactory(
  $state,
  $q,
  $translate,
  $window,
  BulbBusyService,
  BulbErrorService,
  BulbModalService,
  BulbUploadService,
) {
  return {
    restrict: 'E',
    scope: {
      edit: '=*',
      imageTypeDescription: '@',
      isActive: '=',
      isMoving: '=',
      onDelete: '&',
      onEditComplete: '&',
    },
    templateUrl: 'ajs/components/imageeditor/imageeditor.html',
    controller: 'ImageEditorController as imageEditorCtrl',
    bindToController: true,
    transclude: true,
    link(scope, element, attrs) {
      // This variable is used to find the following states on the bulb-page, which will mean that it is
      // a "smaller cover image", using a max height of 420px rather than 500px.
      const $smallerCoverImageStates = $('.bulb-state-unit, .bulb-state-unit-page, .bulb-state-preview-page, .bulb-state-live-page');
      const cropperMaxWidth = 1300;
      const cropperMaxHeight = ($smallerCoverImageStates.length > 0) ? 420 : 500;
      let cropperWidth;
      let cropperHeight;

      let img;
      let asset;
      let assetAspectRatio;
      let isNew;
      const jqWindow = jQuery($window);

      const cropConfig = {
        CROP_COVER_IMAGE: {
          autoCrop: true, // Crop the image automatically when initialized.
          autoCropArea: 1.0, // Define the automatic cropping area size (percentage).
          background: false, // Hide the grid background of the container.
          checkCrossOrigin: false, // Don't check if the image is crossOrigin.
          dragMode: 'move', // Dragging moves the image.
          viewMode: 1, // Require image to fill crop box.
          guides: false, // Hide the dashed lines above the crop box.
          center: false, // Hide the center indicator above the crop box.
          highlight: false, // Hide the white modal above the crop box.
          modal: false, // Hide the black modal above the image and under the crop box.
          movable: true, // Allow moving of the image.
          zoomOnWheel: false, // Disable zooming the image by wheeling mouse.
          responsive: false, // Don't rebuild the cropper when resize the window.
          zoomOnTouch: false, // Don't allow zooming via touch gesture.
          zoomable: false, // Don't allowing zooming the image.
          cropBoxMovable: false, // Don't allow moving the crop box.
          cropBoxResizable: false, // Don't allow to resizing the crop box.
          toggleDragModeOnDblclick: false, // Disable toggling drag mode via double click.
        },
        CROP_AUTHOR_IMAGE: {

        },
        CROP_INLINE_IMAGE: {
          guides: false,
          highlight: false,
          background: false,
        },
      };

      function setCropperSize() {
        cropperWidth = jqWindow.width();
        if (jqWindow.width() >= cropperMaxWidth) {
          cropperHeight = cropperMaxHeight;
        } else {
          cropperHeight = cropperWidth * cropperMaxHeight / cropperMaxWidth;
        }
      }

      // Set the controller's attribute specified by name to value, using scope.$apply.
      function applyControllerValue(name, value) {
        scope.$apply(() => {
          scope.imageEditorCtrl[name] = value;
        });
      }

      // FUTURE : The resize event doesn't work, and the built in responsive option doesn't seem to work either.
      // The failure of the resizing may be related to compositeview-directive.js doing resize behavior for the
      // edit container.
      // Need to add in working support for resizing the cropper when a user resizes the browser window.
      // On resize, do not resize cropper, but center it.
      // function onResize(event) {
      //
      //  // Update the copper height based on the new window size.
      //  setCropperSize();
      //
      //  // Get the current center of the crop
      //  center = {};
      //  var cropData = img.cropper('getData');
      //  center.X = cropData.x + cropData.width/2;
      //  center.Y = cropData.y + cropData.height/2;
      //
      //  // Resize the canvas and container to fit the new size
      //  setCropperData(center);
      //
      //  // move the image back so it is centered as it was prior to the resize
      //  img.cropper('crop');
      // }

      // Destroy the cropper and remove the window resize event handler.
      function destroyCropper() {
        jQuery().cropper('destroy');
        // FUTURE: resize handler disabled for now.  See onResize for more detail.
        //        jqWindow.off('resize', onResize);
      }

      let center;
      let horizontallyCentered;

      // Lay out image in cropper and size the crop box
      function setCropperData(center) {
        scope.imageEditorCtrl.enableButtons = true;
        const cropperAspectRatio = cropperWidth / cropperHeight;
        const canvasData = {};
        let hScale; let vScale; let
          scale;

        // Use the stored center of the asset if we aren't passed a center.
        if (asset.center && center === undefined) {
          center = asset.center;
        }

        if (center) {
          hScale = cropperWidth / asset.width;
          vScale = cropperHeight / asset.height;

          // Center of 'cropped' image will always be centered on either the x or y axis (or both):
          if ((center.X === Math.round(asset.width / 2)) && (center.Y === Math.round(asset.height / 2))) {
            // image is both horizontally and vertically centered, so determine whether it is vertically
            // or horizontally centered based on the aspect ratio.
            horizontallyCentered = assetAspectRatio < cropperAspectRatio;
          } else {
            horizontallyCentered = center.X === Math.round(asset.width / 2);
          }

          if (horizontallyCentered) {
            scale = hScale;
            canvasData.left = 0;
            canvasData.top = cropperHeight / 2 - scale * center.Y;
          } else {
            scale = vScale;
            canvasData.left = (cropperWidth - scale * asset.width) / 2;
            canvasData.top = 0;
          }

          canvasData.width = scale * asset.width;
          canvasData.height = scale * asset.height;

        } else {
          // Edit new image: center image horizontally.
          hScale = cropperWidth / asset.width;
          vScale = cropperHeight / asset.height;

          if (assetAspectRatio > cropperAspectRatio) {
            // image is wider than cropper: use vertical scale
            scale = vScale;
            canvasData.left = (cropperWidth - scale * asset.width) / 2;
          } else {
            // image is taller than cropper: use horizontal scale
            scale = hScale;
            canvasData.left = 0;
          }

          canvasData.width = scale * asset.width;
          canvasData.height = scale * asset.height;
          // Always initialize canvas with new image at the top
          // FUTURE : The image should be vertically centered instead of aligned at the top.
          canvasData.top = 0;
        }
        // Must set CanvasData values before CropBoxData.
        img.cropper('setCanvasData', canvasData);

        const cropBoxData = {};
        cropBoxData.width = cropperWidth;
        cropBoxData.height = cropperHeight;
        cropBoxData.top = 0;
        cropBoxData.left = 0;
        img.cropper('setCropBoxData', cropBoxData);
      }

      // Initialize the imageEditor when the controller's edit property is set.
      scope.$watchCollection('imageEditorCtrl.edit', (edit) => {
        img = jQuery('img', element);

        if (img.length > 0 && edit && edit.asset.url) {
          // save edit values for use by isCommitted function
          asset = angular.copy(edit.asset);
          assetAspectRatio = asset.width / asset.height;
          isNew = edit.isNew;

          scope.imageEditorCtrl.isActive = true;
          scope.imageEditorCtrl.isNew = edit.isNew;

          // DO LATER : Hack: (needed on Firefox only)
          // Before the cropper is initialized,
          // must give the image editor wrapper an explicit height.
          // FUTURE : In the case of cover images, the width will always be window width, won't it?
          //   can't we set that in css and not here?
          img.on('build.cropper', (event) => {
            setCropperSize();
            const wrapper = jQuery('.bulb-image-editor-wrapper');
            wrapper.width(cropperWidth);
            wrapper.height(cropperHeight);
          });

          img.on('built.cropper', (event) => {
            setCropperData(center);

            // FUTURE : the resize event handler is not registered because the hander's resizing of the
            // cropper doesn't work yet.
            //            jqWindow.on('resize', onResize);

            // DO LATER : Hack: (needed on Chrome only)
            // "overflow-y: hidden" style is not set correctly on header node
            // unless 'isMoving' is toggled here.
            try {
              applyControllerValue('isMoving', true);
              applyControllerValue('isMoving', false);
            } catch (error) {
            }
          });

          let cropBoxData;
          let halfWidth;
          let halfHeight;

          // Set isMoving when drag/move starts.
          // The parts of the image outside the cropper window are only visible when isMoving is true.
          img.on('cropstart.cropper', (event) => {
            applyControllerValue('isMoving', true);
            cropBoxData = img.cropper('getCropBoxData');
            halfWidth = cropBoxData.width / 2;
            halfHeight = cropBoxData.height / 2;
          });

          // Clear isMoving when drag/move ends.
          // The parts of the image outside the imageEditor window are not visible when isMoving is false.
          img.on('cropend.cropper', (event) => {
            applyControllerValue('isMoving', false);
            cropBoxData = null;
            halfWidth = null;
            halfHeight = null;
          });

          // Initialize the cropper.
          img.cropper(cropConfig[edit.cropType]);
        }
      });

      // When user clicks the Cancel button,
      // cancel the upload, destroy the cropper, and
      // call the onEditComplete function, if any, passing it null (no data).
      scope.$watch('imageEditorCtrl.isCanceled', (isCanceled) => {
        if (isCanceled) {
          scope.imageEditorCtrl.isActive = false;
          if (isNew) {
            // Cancel the upload: delete the unsaved asset on the server.
            BulbUploadService.cancelUpload(asset.id);
          }
          if (attrs.onEditComplete) {
            BulbBusyService.showBusyDuring(
              $q.when(scope.imageEditorCtrl.onEditComplete({ data: null })).finally((result) => {
                destroyCropper();
              }),
            );
          }
        }
        scope.imageEditorCtrl.isCanceled = false;
      });

      // When user clicks the Save button,
      // destroy the cropper, and call the onEditComplete function, if any, passing it the crop data.
      // A single argument named 'data' is passed to the onEditComplete function.
      // data is either null, or an object with the following properties:
      //    asset: the asset field of imageEditorCtrl.edit, received by the $watch on imageEditorCtrl.edit,
      //       initiating this edit
      //    center: an object containing the following fields:
      //      X: the X value of the center point of the cropped image, scaled to the original image width
      //      Y: the Y value of the center point of the cropped image, scaled to the original image height
      //    width: the original image width
      //    height: the original image height
      // The onEditComplete function's return value is ignored.
      scope.$watch('imageEditorCtrl.isCommitted', (isCommitted) => {
        if (isCommitted) {

          scope.imageEditorCtrl.isActive = false;

          const canvasData = img.cropper('getCanvasData');
          const cropBoxData = img.cropper('getCropBoxData');

          // Pass cropped image data to onEditComplete function, if defined.
          if (attrs.onEditComplete) {

            const scale = asset.width / canvasData.width;
            const center = {
              X: Math.round(scale * (cropBoxData.width / 2 - canvasData.left)),
              Y: Math.round(scale * (cropperHeight / 2 - canvasData.top)),
            };
            const data = {
              asset,
              center,
              width: asset.width,
              height: asset.height,
            };

            BulbBusyService.showBusyDuring(
              // invoke onEditComplete function
              $q.when(scope.imageEditorCtrl.onEditComplete({ data })).finally((result) => {

                $state.reload();
                destroyCropper();
              }),
            );
          } else {

            destroyCropper();
          }
          if (isNew) {
            // Mark the upload ended.
            BulbUploadService.endUpload(asset.id);
          }
        }
        scope.imageEditorCtrl.isCommitted = false;
      });

      // When user clicks the Delete button, turn off isActive,
      // then invoke the onDelete function, if any.
      // No arguments are passed to the onDelete function.
      // The onDelete function should return a promise.
      scope.$watch('imageEditorCtrl.isDeleted', (isDeleted) => {
        if (isDeleted) {
          scope.imageEditorCtrl.isActive = false;
          // If onDelete function is defined,
          // show a confirm delete modal,
          // and if confirmed, invoke the onDelete function.
          if (attrs.onDelete) {
            $translate(
              'modal_delete_confirm_body',
              { type: scope.imageEditorCtrl.imageTypeDescription },
            ).then((bodyText) => {
              BulbModalService.show({
                titleCode: 'modal_delete_confirm_title',
                bodyText,
                okButtonCode: 'button_delete',
                showCancelButton: false,
              }).then(() => {
                // user confirmed the confirm delete modal
                BulbBusyService.showBusyDuring(
                  $q.when(scope.imageEditorCtrl.onDelete()).then(() => {
                    scope.imageEditorCtrl.isActive = false;
                  }, (reason) => {
                    scope.imageEditorCtrl.isActive = true;
                    BulbErrorService.error(`Cannot delete: ${reason}`);
                  }),
                );
              }, (reason) => {
                // user canceled the confirm delete modal
                scope.imageEditorCtrl.isActive = true;
              });
            });
          }
        }
        // reset isDeleted
        scope.imageEditorCtrl.isDeleted = false;
      });
    },
  };
}
